import { useQuery } from '@tanstack/react-query';

import { GetDeviceIdListResponse } from '@/api/deviceIdList/types';
import { RequestOptions, axios, requestConfig } from '@/common/axios';
import { QueryConfig } from '@/common/react-query';
import { useViewToken } from '@/context/ViewTokenContext';
import { pickTruthy } from '@/utils';

export type GetDeviceIdListParams = { userFilter?: string | null; adminAllDevices?: boolean };

export const getDeviceIdList = async (
    params: GetDeviceIdListParams,
    options?: RequestOptions
): Promise<GetDeviceIdListResponse> =>
    axios.get<GetDeviceIdListResponse, GetDeviceIdListResponse>('/fetch/device-id-list', {
        params: pickTruthy(params),
        ...requestConfig(options),
    });

type UseDeviceIdListOptions = {
    config?: QueryConfig<typeof getDeviceIdList>;
} & GetDeviceIdListParams;

export const useDeviceIdList = ({
    config: { enabled = true, ...config } = {},
    ...queryParams
}: UseDeviceIdListOptions = {}) => {
    const { loading: loadingToken, viewToken } = useViewToken();
    return useQuery<GetDeviceIdListResponse>({
        ...config,
        enabled: enabled && !loadingToken,
        queryKey: ['device-id-list', queryParams, viewToken],
        queryFn: ({ signal }) => getDeviceIdList(queryParams, { viewToken, signal }),
        staleTime: 1000 * 60 * 5, // 5 minutes
    });
};
